import type { HttpPost } from '@/shared/infra/http'
import type {
  ExchangeImpersonationHandoff,
  ExchangeImpersonationHandoffParams,
} from '@/modules/auth/use-cases'

type ExchangeImpersonationHandoffApiResponse = {
  access_token: string
  refresh_token: string
}

export class EdgeExchangeImpersonationHandoffRepository {
  constructor(private readonly httpClient: HttpPost) {}

  execute: ExchangeImpersonationHandoff = async (params) => {
    const response = await this.httpClient.post<
      ExchangeImpersonationHandoffParams,
      ExchangeImpersonationHandoffApiResponse
    >({
      url: '/internal-admin/impersonation/handoff/exchange',
      body: { code: params.code },
    })
    return {
      accessToken: response.access_token,
      refreshToken: response.refresh_token,
    }
  }
}
